import React from 'react';
import { PROCESS_STEPS } from '../mock';
import { ArrowRight } from 'lucide-react';

export const ProcessSection = () => {
  return (
    <section className="py-28 lg:py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Unser Prozess
          </div>
          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 mb-6 tracking-tight">
            So einfach geht's
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-normal">
            Von der Kontaktaufnahme bis zum fertigen Gutachten – in 4 Schritten
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {PROCESS_STEPS.map((step, index) => (
            <div key={index} className="relative group">
              <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-100 rounded-3xl p-10 h-full hover:border-brand-green/30 hover:shadow-2xl transition-all duration-500">
                <div className="w-14 h-14 bg-brand-green text-white rounded-2xl flex items-center justify-center mb-8 font-bold text-2xl shadow-lg shadow-brand-green/30">
                  {step.step}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 tracking-tight">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
              
              {index < PROCESS_STEPS.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <div className="w-8 h-8 bg-brand-green/10 rounded-full flex items-center justify-center border border-brand-green/20">
                    <ArrowRight className="w-5 h-5 text-brand-green" />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};